export const contactDetails = {
  content:
    "To find out more about development sites and commercial property in the Coventry & Warwickshire area email" +
    ' <a href="mailto:property@investcw.co.uk">property@investcw.co.uk</a> to arrange a call back.',
};
